import React from 'react';

const FloatingElements = () => {
  return (
    <div className="floating-elements">
      <div className="floating-bubble bubble-1">🎈</div>
      <div className="floating-bubble bubble-2">⭐</div>
      <div className="floating-bubble bubble-3">🌟</div>
      <div className="floating-bubble bubble-4">🎵</div>
      <div className="floating-bubble bubble-5">🌈</div>
      <div className="floating-bubble bubble-6">☁️</div>
      <div className="floating-bubble bubble-7">🎨</div>
      <div className="floating-bubble bubble-8">🦋</div>
      <div className="floating-shape shape-1"></div>
      <div className="floating-shape shape-2"></div>
      <div className="floating-shape shape-3"></div>
      <div className="floating-shape shape-4"></div>
    </div>
  );
};

export default FloatingElements; 